import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { LocalStorageKeys, MultipleLocalStorageKeys } from 'constants/local-storage';
import { getUnitSystem } from 'constants/body-height-weight';
import { ABLE_PLAN } from 'constants/able-plan';
import { GtagKeys } from 'constants/analytics';
import { APP_NAME, APP_SOURCE_DESKTOP, APP_SOURCE_MOBILE, APP_TYPE_APP, APP_TYPE_PWA } from 'constants/app-name';
import { IntakeFormKey } from 'constants/intake-form';
import { UserGeolocationKeys } from 'constants/user-geolocation';
import { AGES } from 'constants/customer';

import { getLocalStorageData } from './local-storage-data';
import { getCookie } from './cookie';
import { detectBrowser, detectPlatform, isDesktop } from 'helpers/detect-device-type';

import { getCustomerDetails } from 'pages/checkout/account-form';
import { getShippingAddressDetails } from 'pages/checkout/shipping-address-form';

dayjs.extend(customParseFormat);

const getBodyHeight = () => {
    const heightCm = localStorage.getItem(MultipleLocalStorageKeys.bodyHeightWeightKeys.heightCm);

    const height = Number(heightCm);

    return Number(height);
};

const getBodyWeightCurrent = () => {
    return Number(localStorage.getItem(MultipleLocalStorageKeys.bodyHeightWeightKeys.weightKg));
};

const getBodyWeightGoal = (weightGoal: string) => {
    return Number(weightGoal);
};

const getSignUpDataFromLocalStorage = () => {

    const localStorageData = getLocalStorageData(Object.values(LocalStorageKeys));

    return {
        ...localStorageData,
        height: getBodyHeight(),
        weightCurrent: getBodyWeightCurrent(),
    };
};

export const getCid = () => {
    const local = localStorage.getItem('cid');
    const cookie = getCookie('cid');
    const session = sessionStorage.getItem('cid');

    return local || cookie || session;
};

// @param: additionalData - object with post data not related to local storage
export const getSignUpData = (paymentData: any = {}) => {
    const customer = getCustomerDetails();
    const shippingAddress = getShippingAddressDetails();

    const data = getSignUpDataFromLocalStorage();
    const unitSystem = getUnitSystem();

    const pwaNativeSplitVariationExp = true;

    data.plan = ABLE_PLAN;

    data.weightGoal = getBodyWeightGoal(data.weightGoal);

    data.languageCode = window.navigator.language?.toLowerCase() || window.navigator.userLanguage?.toLowerCase() || 'en';

    const questions = JSON.parse(localStorage.getItem(IntakeFormKey) as string);
    data.intakeForm = questions ? Object.values(questions) : [];

    data.cid = getCid();
    data.gclid = localStorage.getItem('gclid') || '';
    data.userID = localStorage.getItem('userID');
    data.clickID = localStorage.getItem('clickId') || '';
    data.advertisingID = localStorage.getItem('userID'); // @TODO: why they are the same?
    data.kountSessionID = localStorage.getItem('kount_session_id') || '';
    data.gtagClientId = localStorage.getItem(GtagKeys.gtagClientId);
    data.jsonMetadata = localStorage.getItem('json_metadata');
    data.appName = `${APP_NAME} ${ABLE_PLAN}`;
    data.subdomain = window.location.hostname.split('.').slice(0, -2).join('.') || '-';
    data.type = 'Primer.io';
    data.platform = isDesktop() ? `desktop: ${detectBrowser()}` : detectPlatform();
    data.source = isDesktop() ? APP_SOURCE_DESKTOP : APP_SOURCE_MOBILE;
    data.appType = pwaNativeSplitVariationExp ? APP_TYPE_PWA : APP_TYPE_APP;
    data.pwaAutoLogin = 'true';

    data.unit = unitSystem;
    data.unitWeight = unitSystem;
    data.unitHeight = unitSystem;

    const formattedDate = dayjs(customer.dateOfBirth, 'DD/MM/YYYY');
    const dateDiff = dayjs().diff(formattedDate, 'year');
    data.age = AGES.find(({ min, max }) => min <= dateDiff && max >= dateDiff)?.age || '';

    customer.phone = `${customer.phone}`;
    data.customer = customer;
    data.shippingAddress = shippingAddress;

    data.country = localStorage.getItem(UserGeolocationKeys.countryCode);
    data.timezone = localStorage.getItem(UserGeolocationKeys.timezone);

    return {
        ...data,
        ...paymentData,
    }
};
